import { Menu } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useCallback, useLayoutEffect, useRef, useState } from 'react';

function NRMenuRoot({ action, open = false, PaperProps, slotProps, ...props }) {
  const popoverActionsRef = useRef(null);
  const [paperNode, setPaperNode] = useState(null);
  const incomingPaperProps = slotProps?.paper ?? PaperProps;

  const handleActionRef = useCallback(
    instance => {
      popoverActionsRef.current = instance;
      if (typeof action === 'function') {
        action(instance);
      } else if (action) {
        action.current = instance;
      }
    },
    [action]
  );

  const handlePaperRef = useCallback(
    node => {
      setPaperNode(node);
      const paperRef = incomingPaperProps?.ref;
      if (typeof paperRef === 'function') {
        paperRef(node);
      } else if (paperRef) {
        paperRef.current = node;
      }
    },
    [incomingPaperProps?.ref]
  );

  useLayoutEffect(() => {
    if (!open || !paperNode || typeof ResizeObserver === 'undefined') {
      return undefined;
    }

    const observer = new ResizeObserver(() => {
      popoverActionsRef.current?.updatePosition();
    });
    observer.observe(paperNode);

    return () => observer.disconnect();
  }, [open, paperNode]);

  return (
    <Menu
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      {...props}
      open={open}
      action={handleActionRef}
      slotProps={{
        ...slotProps,
        paper: {
          ...incomingPaperProps,
          ref: handlePaperRef
        }
      }}
    />
  );
}

export const NRMenu = styled(NRMenuRoot)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 4,
    marginTop: theme.spacing(1),
    minWidth: 180,
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0'
    },
    '& .MuiMenuItem-root': {
      ...theme.typography.body1,
      '& .MuiSvgIcon-root': {
        fontSize: 24,
        color: theme.palette.text.icon,
        marginRight: theme.spacing(1.5)
      },
      '&:active': {
        backgroundColor: theme.palette.background.paper
      }
    }
  }
}));
